import { render } from "./resellerPage.vue?vue&type=template&id=fc59d08a"
import script from "./resellerPage.vue?vue&type=script&lang=js"
export * from "./resellerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__